/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import {
    bool, object, string, func, array, oneOfType,
} from 'prop-types';

import { withStyles } from '@material-ui/styles';
import Grid from '@material-ui/core/Grid';

import { withRouter } from 'react-router';
import { Helmet } from 'react-helmet';
import { QueryClient, QueryClientProvider } from 'react-query';

import { getLoaderStatus, getPassportLoader, getPaymentError } from '../../../../../../../state/ducks/Checkout/ducks/Common/Common-Selectors';
import { loadShopRunner } from '../../../../../../../state/ducks/Checkout/ducks/Global/Global-Actions';

import * as app from '../../../../../../../state/ducks/App';
import { getFeatureFlags } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Selectors';

import ABTestSalesForceBuilder from '../ABTestSaleForce/ABTestSalesForceBuilder';
import AccertifyWrapper from '../Accertify/AccertifyWrapper/AccertifyWrapper';
import EligiblePaymentMethodContainer from '../EligiblePaymentMethodContainer/EligiblePaymentMethodContainer';
import GraphqlRelationship from '../GraphqlComponents/GraphqlRelationship';
import KlarnaPaymentWrapper from '../PaymentButtonBuilder/buttons/KlarnaPayment/KlarnaPaymentWrapper/KlarnaPaymentWrapper';
import LoadPaypalScript from '../../PaymentButton/PaypalButton/LoadPaypalScript/LoadPaypalScript';
import ModalContextProvider from '../ModalContext/ModalContextProvider';
import ModalBuilder from '../ModalContext/ModalBuilder';
import PazePaymentWrapper from '../PaymentButtonBuilder/buttons/ChasePaze/PazePaymentWrapper';
import SiteLoader from '../SiteLoader/SiteLoader';

import { anchorErrorCommonMessage } from '../Helpers/Helper';
import { getOrderItemErrors } from '../../../../../../../state/ducks/Checkout/ducks/Common/ducks/Error/Error-Selector';
import { getPageType } from '../Helpers/pageHelpers';
import { clearWallet } from '../../../../../../../state/ducks/Member/ducks/Wallet/Wallet-Actions';
import { clearAddressBook } from '../../../../../../../state/ducks/Member/ducks/AddressBook/AddressBook-Actions';
import { getWalletCards } from '../../../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { getIsWriteScopeCheckout } from '../../../../../../../state/ducks/Checkout/ducks/Global/Global-Selectors';
import { getRegisterAddressBookList } from '../../../../../../../state/ducks/MfeCheckout/ducks/Member/AddressBookEntry/AddressBookEntry-Selector';
import { clearAllChatgptMessage } from '../../../../../../../state/ducks/MfeCheckout/ducks/CartItem/ChatGptMessage/ChatGptMessage-Actions';
import { getChatGptMessageData } from '../../../../../../../state/ducks/MfeCheckout/ducks/CartItem/ChatGptMessage/ChatGptMessage-Selectors';

const appConfigSelectors = app.ducks.config.selectors;
const styles = (theme) => ({
    // Avoid the open modal or dialog scroll up (top)
    '@global': {
        // body: {
        //     overflowY: 'auto !important',
        // },
        // 'html > body': {
        //     overflowY: 'auto !important',
        // },
        '#root': {
            // overflow: 'auto !important',
            overflow: 'visible',
        },
        '#root[aria-hidden="true"]': {
            position: 'static !important',
            left: 'auto',
            right: 'auto',
            top: 'auto',
            bottom: 'auto',
        },
        'body > div[role="presentation"], body > div[role="tooltip"],  .MuiChip-root, .MuiButton-root, .MuiTypography-root, .MuiTypography-body1 .MuiChip-root, .MuiButton-root, .MuiTypography-root, .MuiTypography-body1, .MuiInputBase-root': {
            fontSize: '16px',
        },
        'body, h1, input, select, .greetingsMessage textarea, button, .MuiChip-root, .MuiButton-root, .MuiTypography-root, .MuiTypography-body1, .MuiInputBase-root': {
            fontFamily: `${theme.typography.fontFamily} !important`,
        },
        'input::placeholder, textarea::placeholder, .MuiInputBase-input::placeholder, .MuiOutlinedInput-input::placeholder': {
            fontFamily: `${theme.typography.fontFamily} !important`,
            opacity: 1,
        },
        'input::-webkit-input-placeholder, textarea::-webkit-input-placeholder, .MuiInputBase-input::-webkit-input-placeholder, .MuiOutlinedInput-input::-webkit-input-placeholder': {
            fontFamily: `${theme.typography.fontFamily} !important`,
        },
        'input::-moz-placeholder, textarea::-moz-placeholder, .MuiInputBase-input::-moz-placeholder, .MuiOutlinedInput-input::-moz-placeholder': {
            fontFamily: `${theme.typography.fontFamily} !important`,
            opacity: 1,
        },
        'input:-ms-input-placeholder, textarea:-ms-input-placeholder, .MuiInputBase-input:-ms-input-placeholder, .MuiOutlinedInput-input:-ms-input-placeholder': {
            fontFamily: `${theme.typography.fontFamily} !important`,
        },
        '.MuiInputLabel-root, .MuiFormLabel-root, .MuiInputLabel-formControl, .MuiInputLabel-outlined, .MuiFormLabel-filled, .MuiFormLabel-focused': {
            fontFamily: `${theme.typography.fontFamily} !important`,
        },
        '@media screen and (-webkit-min-device-pixel-ratio:0)': {
            'select:focus, textarea:focus, input:focus': {
                fontSize: '16px !important',
            },
        },
        'footer, #global_footer_container': {
            backgroundColor: '#F4F4F4',
            marginBottom: '-23px',
            marginTop: '0',
        },
    },
    root: {
        minHeight: 'calc(110vh - 236px)',
        fontSize: '16px',
    },
});

class CheckoutWrapper extends React.Component {
    componentDidMount() {
        const {
            loadSr, featureFlags = {},
        } = this.props;
        const isShopRunnerEnabled = featureFlags['is-shoprunner-enabled'];
        if (isShopRunnerEnabled) {
            loadSr(); // calls shoprunner scripts to load
        }

        if (typeof window !== 'undefined' && typeof document !== 'undefined') {
            if (document.body) {
                document.body?.removeAttribute('style');
                document.body.className = '';
            }
            if (document.getElementById('root') && document.getElementById('root').removeAttribute) {
                document.getElementById('root').removeAttribute('aria-hidden');
                document.getElementById('root').removeAttribute('style');
                document.getElementById('root').removeAttribute('aria-live');
                document.getElementById('root').className = '';
            }

            if (document?.getElementsByTagName && document.getElementsByTagName('html')?.[0]) {
                document.getElementsByTagName('html')[0].className = '';
            }
        }
    }

    componentDidUpdate(prevProps) {
        const {
            brandId, errorPayment, featureFlags = {},
            loadSr, orderItemErrors, isWriteScopeCheckout,
            callClearWallet, callClearAddressBook, walletEntries, addressBookEntries,
        } = this.props;

        const isShopRunnerEnabled = featureFlags['is-shoprunner-enabled'];
        if (prevProps.brandId !== brandId && isShopRunnerEnabled) {
            loadSr(); // Fall back to call only if brandId is set
        }

        // General and inline errors in the current page
        if (
            prevProps.orderItemErrors?.recipient !== orderItemErrors?.recipient
            || Object.toString(prevProps.errorPayment || {}) !== Object.toString(errorPayment || {})
        ) {
            anchorErrorCommonMessage();
        }

        if (prevProps.isWriteScopeCheckout !== isWriteScopeCheckout) {
            if (Array.isArray(addressBookEntries) && addressBookEntries.length) {
                callClearAddressBook();
            }

            if (Array.isArray(walletEntries) && walletEntries.length) {
                callClearWallet();
            }
        }

        if (typeof window !== 'undefined' && typeof document !== 'undefined') {
            if (document.body?.className?.indexOf('bx-') >= 0) {
                console.log('removing bx');
                document.body.className = '';
            }

            if (
                document?.getElementsByTagName
                && document.getElementsByTagName('html')?.[0]
                && document.getElementsByTagName('html')[0].className
            ) {
                console.log('removing html className');
                document.getElementsByTagName('html')[0].className = '';
            }
        }
    }

    componentWillUnmount() {
        const { featureFlags, callClearAllChatgptMessage, chatGptMessageData } = this.props;
        if (featureFlags['is-chat-gpt-enabled'] && chatGptMessageData && Object.keys(chatGptMessageData).length > 0) {
            callClearAllChatgptMessage();
        }
    }

    render() {
        const {
            classes, showLoadingMessage, children,
            passportLoader, featureFlags, history,
            ldClient,
        } = this.props;
        const pageType = getPageType(history);
        const queryClient = new QueryClient();

        const isClientSideDetectionsEnabled = typeof window !== 'undefined'
            && !window.location.host.includes('localhost')
            && featureFlags['advanced-client-side-detections-enabled'];

        return (
            <Grid id={featureFlags['which-checkout-variation'] === 'enterprise2' ? 'pwa-enterprise2' : 'pwa-universal'} className={classes.root} container>
                <Helmet>
                    <link href="https://fonts.googleapis.com/css2?family=Cinzel+Decorative&family=Fenix&family=Fredericka+the+Great&family=Happy+Monkey&family=Parisienne&family=Philosopher:ital@0;1&display=swap" rel="stylesheet" />
                    {
                        isClientSideDetectionsEnabled
                        && (
                            <script src="/_fs-ch-1T1wmsGaOgGaSxcX/assets/script.js" />
                        )
                    }
                </Helmet>
                {featureFlags && <ABTestSalesForceBuilder featureFlags={featureFlags} pageType={pageType} />}
                {featureFlags['is-paypal-braintree-enabled'] && <LoadPaypalScript />}
                <Grid container>
                    <QueryClientProvider client={queryClient}>
                        {(showLoadingMessage || passportLoader) && <SiteLoader />}
                        <AccertifyWrapper isAccertifyEnabled={featureFlags['is-checkout-accertify-enabled']}>
                            <KlarnaPaymentWrapper>
                                <PazePaymentWrapper isPazeEnabled={featureFlags['is-paze-payment-enabled']}>
                                    <EligiblePaymentMethodContainer>
                                        <ModalContextProvider>
                                            {
                                                !['cart', 'payment'].includes(pageType)
                                            && <GraphqlRelationship pageType={pageType} />
                                            }
                                            {children}
                                            <ModalBuilder pageType={pageType} ldClient={ldClient} />
                                        </ModalContextProvider>
                                    </EligiblePaymentMethodContainer>
                                </PazePaymentWrapper>
                            </KlarnaPaymentWrapper>
                        </AccertifyWrapper>
                    </QueryClientProvider>
                </Grid>
            </Grid>
        );
    }
}

CheckoutWrapper.defaultProps = {
    brandId: '',
    children: null,
    errorPayment: {},
    orderItemErrors: {},
    passportLoader: false,
    showLoadingMessage: false,
    ldClient: null,
};

CheckoutWrapper.propTypes = {
    addressBookEntries: array.isRequired,
    brandId: string,
    callClearAddressBook: func.isRequired,
    callClearAllChatgptMessage: func.isRequired,
    callClearWallet: func.isRequired,
    classes: object.isRequired,
    chatGptMessageData: object.isRequired,
    children: oneOfType([array, object]),
    errorPayment: object,
    featureFlags: object.isRequired,
    history: object.isRequired,
    isWriteScopeCheckout: bool.isRequired,
    loadSr: func.isRequired,
    orderItemErrors: object,
    passportLoader: bool,
    showLoadingMessage: bool,
    walletEntries: array.isRequired,
    ldClient: object,

};

const mapStateToProps = (state) => ({
    addressBookEntries: getRegisterAddressBookList(state),
    brandId: appConfigSelectors.getCurrentBrandId(state),
    chatGptMessageData: getChatGptMessageData(state),
    errorPayment: getPaymentError(state),
    featureFlags: getFeatureFlags(state),
    isWriteScopeCheckout: getIsWriteScopeCheckout(state),
    orderItemErrors: getOrderItemErrors(state),
    passportLoader: getPassportLoader(state),
    showLoadingMessage: getLoaderStatus(state),
    walletEntries: getWalletCards(state),
});

const mapDispatchToProps = (dispatch) => ({
    loadSr: bindActionCreators(loadShopRunner, dispatch),
    callClearWallet: bindActionCreators(clearWallet, dispatch),
    callClearAddressBook: bindActionCreators(clearAddressBook, dispatch),
    callClearAllChatgptMessage: bindActionCreators(clearAllChatgptMessage, dispatch),
});

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles),
)(CheckoutWrapper);
